import { getAuthForUserSocket, setUserApiBase } from 'api/auth'
import { Channel, Socket } from 'phoenix'
import { pathOr } from 'ramda'
import { CHANNEL_EVENTS, connectToChannel, connectToSocket,SOCKET_CHANNELS, SOCKET_CLUSTER } from 'utils/socket'

import SocketManager from '../socketManager'

interface SocketConnectProps {
  orgId: number,
  accessToken: string
}

class UserSocketManager extends SocketManager {
  _heartbeatInterval: number
  _socket: Socket
  _channel: { channel: Channel }

  constructor() {
    super()
    this._socket = null
    this._channel = null
    this._heartbeatInterval = null
  }

  async connect({ orgId, accessToken }: SocketConnectProps) {
    setUserApiBase()

    const { data:socketUserAuth } = await getAuthForUserSocket({
      access_token: accessToken
    })

    this._socket = await connectToSocket({ ...socketUserAuth, socketCluster: SOCKET_CLUSTER.USER, orgId, ip: socketUserAuth.remote_ip })
    this._fireSocketConnectedEvent(SOCKET_CLUSTER.USER)

    this._channel = await connectToChannel({ socket: this._socket, channelEvents: CHANNEL_EVENTS.CHAT, socketAuth: socketUserAuth, channelName: SOCKET_CHANNELS.CHAT, orgId })
    this._fireChannelConnectedEvent('chat', SOCKET_CLUSTER.USER, this._channel)

    this._pushMessageToChannel('data:conversations')
  }

  sendMessage = (payload: Record<string, any>) => {
    this._pushMessageToChannel('request:sendMessage', payload)
  }

  _pushMessageToChannel = (name: string,  payload?: Record<string, any>) => {
    const hasChannel = pathOr(false, ['_channel', 'channel'], this)

    if (hasChannel) {
      this._channel.channel.push(name, payload)
    }
  }
}

export default new UserSocketManager()
